/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinalizeUsageBasedInvoices200ResponseFailuresInner } from './FinalizeUsageBasedInvoices200ResponseFailuresInner';
import {
    FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSON,
    FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped,
    FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSON,
    FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSONTyped,
} from './FinalizeUsageBasedInvoices200ResponseFailuresInner';
import type { FinalizeUsageBasedInvoices200ResponseInvoicesInner } from './FinalizeUsageBasedInvoices200ResponseInvoicesInner';
import {
    FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSON,
    FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped,
    FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSON,
    FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped,
} from './FinalizeUsageBasedInvoices200ResponseInvoicesInner';

/**
 * 
 * @export
 * @interface FinalizeUsageBasedInvoices200Response
 */
export interface FinalizeUsageBasedInvoices200Response {
    /**
     * 
     */
    success?: boolean;
    /**
     * 
     */
    invoicesFinalized?: number;
    /**
     * 
     */
    billingPeriod?: string;
    /**
     * 
     */
    invoices?: Array<FinalizeUsageBasedInvoices200ResponseInvoicesInner>;
    /**
     * 
     */
    failures?: Array<FinalizeUsageBasedInvoices200ResponseFailuresInner>;
}

/**
 * Check if a given object implements the FinalizeUsageBasedInvoices200Response interface.
 */
export function instanceOfFinalizeUsageBasedInvoices200Response(value: object): value is FinalizeUsageBasedInvoices200Response {
    return true;
}

export function FinalizeUsageBasedInvoices200ResponseFromJSON(json: any): FinalizeUsageBasedInvoices200Response {
    return FinalizeUsageBasedInvoices200ResponseFromJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeUsageBasedInvoices200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'invoicesFinalized': json['invoicesFinalized'] == null ? undefined : json['invoicesFinalized'],
        'billingPeriod': json['billingPeriod'] == null ? undefined : json['billingPeriod'],
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSON)),
        'failures': json['failures'] == null ? undefined : ((json['failures'] as Array<any>).map(FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSON)),
    };
}

export function FinalizeUsageBasedInvoices200ResponseToJSON(json: any): FinalizeUsageBasedInvoices200Response {
    return FinalizeUsageBasedInvoices200ResponseToJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseToJSONTyped(value?: FinalizeUsageBasedInvoices200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'invoicesFinalized': value['invoicesFinalized'],
        'billingPeriod': value['billingPeriod'],
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSON)),
        'failures': value['failures'] == null ? undefined : ((value['failures'] as Array<any>).map(FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSON)),
    };
}

